// import { Col } from "reactstrap";
import { UL, } from "../../../AbstractElements";
import NotificationHeader from "./NotificationHeader/NotificationHeader";
import UserProfile from "./UserProfile/UserProfile";
import ZoomInOut from "./ZoomInOut/ZoomInOut";
import { FaYoutube } from "react-icons/fa";
const MainHeader = () => {
  return (
    <div className="page-main-header">
      {/* <SearchInput /> */}
      <div className="nav-right d-flex  justify-content-start justify-content-md-between w-100">
        <div className="d-none d-md-flex align-items-center">
          <div className="header-youtube">
            <a
              href="https://www.youtube.com/@SumanSinghSukanyaSwastikcare"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-link"
            >
              <FaYoutube />
              <span>Watch Us on YouTube</span>
            </a>
          </div>
        </div>
        <UL className="header-right flex-row simple-list justify-content-md-end overflow-visible gap-2 gap-md-0">
          {/* <DarkMode/> */}
          {/* <ResponsiveSearch /> */}
          <ZoomInOut />
          <NotificationHeader />
          {/* <BookmarkHeader /> */}
          {/* <CartHeader /> */}
          {/* <MessagesHeader /> */}
          <UserProfile />
        </UL>
      </div>
    </div>
  );
};

export default MainHeader;
